var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M6.75,3V5.25M17.25,3V5.25M3,18.75V7.5A2.25,2.25,0,0,1,5.25,5.25h13.5A2.25,2.25,0,0,1,21,7.5V18.75m-18,0A2.25,2.25,0,0,0,5.25,21h13.5A2.25,2.25,0,0,0,21,18.75m-18,0v-7.5A2.25,2.25,0,0,1,5.25,9h13.5A2.25,2.25,0,0,1,21,11.25v7.5m-9-6h.008v.008H12ZM12,15h.008v.008H12Zm0,2.25h.008v.008H12ZM9.75,15h.008v.008H9.75Zm0,2.25h.008v.008H9.75ZM7.5,15h.008v.008H7.5Zm0,2.25h.008v.008H7.5Zm6.75-4.5h.008v.008H14.25Zm0,2.25h.008v.008H14.25Zm0,2.25h.008v.008H14.25Zm2.25-4.5h.008v.008H16.5Zm0,2.25h.008v.008H16.5Z",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#4d677e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarH);
export default __webpack_public_path__ + "static/media/calendar-h.7515f790.svg";
export { ForwardRef as ReactComponent };